import { Stack, Typography } from '@mui/material';

import { formatNumberByThousands } from '@/shared/helpers/format.helpers';

type TotalAmountProps = {
  paymentSum: number;
};

export const TotalAmount = (props: TotalAmountProps) => (
  <Stack direction="row" spacing={1} justifyContent="flex-end">
    <Typography variant="Headline/Bold/small">{formatNumberByThousands(props.paymentSum)}</Typography>
    <Typography variant="Headline/small" color="neutral.700">
      UZS
    </Typography>
  </Stack>
);
